import { Color, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'

// Lumen Table.Content uses overflow-x:auto, which becomes the sticky containing block —
// vertical sticky only works when that same element is also the vertical scrollport.
// Nested selectors target Lumen's table markup (Table root + Content scroll wrapper, thead/th).
export const FecImportMappingTableScrollAreaWrapper = styled.div`
  flex: 1;
  width: 100%;
  min-height: 0;

  & > div {
    height: 100%;
    min-height: 0;
  }

  & > div > div {
    height: 100%;
    max-height: 100%;
    overflow-y: auto;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: ${zIndex.TableStickyHeader};
    background-color: ${Color.White};
  }
`
